/* =====================================================================
   NX-FX — Bewegungs-Engine
   Selbst-anhängend: findet bekannte Klassen und rüstet Effekte nach.
   Ein einziger rAF-Loop, IntersectionObserver-gesteuert, Reduced-Motion-safe.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__nxFx) return; window.__nxFx = true;

  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COARSE  = matchMedia('(pointer: coarse)').matches;
  var raf = requestAnimationFrame;

  /* ---------- kleine Helfer ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* =================================================================
     1) HERO — Partikel-Feld (Staub im Lichtkegel)
     ================================================================= */
  function initParticles(host) {
    if (REDUCED || host.dataset.nxParticles) return;
    host.dataset.nxParticles = '1';
    var c = document.createElement('canvas');
    c.className = 'nx-fx-canvas';
    c.setAttribute('aria-hidden', 'true');
    host.insertBefore(c, host.firstChild);
    var ctx = c.getContext('2d'), dpr = Math.min(devicePixelRatio || 1, 2);
    var w = 0, h = 0, parts = [], visible = true;

    function size() {
      var r = host.getBoundingClientRect();
      w = r.width; h = r.height;
      c.width = w * dpr; c.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = clamp(Math.round(w * h / 26000), 18, 70);
      parts = [];
      for (var i = 0; i < n; i++) parts.push({
        x: Math.random() * w, y: Math.random() * h,
        r: Math.random() * 1.7 + .35,
        vy: -(Math.random() * .16 + .04),
        vx: (Math.random() - .5) * .12,
        a: Math.random() * .5 + .12,
        tw: Math.random() * Math.PI * 2
      });
    }
    function frame() {
      if (!visible) return;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y += p.vy; p.x += p.vx; p.tw += .02;
        if (p.y < -8) { p.y = h + 8; p.x = Math.random() * w; }
        if (p.x < -8) p.x = w + 8; if (p.x > w + 8) p.x = -8;
        var a = p.a * (.6 + .4 * Math.sin(p.tw));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = 'rgba(168,206,255,' + a.toFixed(3) + ')';
        ctx.fill();
      }
      raf(frame);
    }
    size(); frame();
    addEventListener('resize', debounce(size, 200));
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var was = visible; visible = e.isIntersecting;
        if (visible && !was) raf(frame);
      });
    }, { threshold: 0 }).observe(host);
  }

  /* =================================================================
     2) 3D-TILT — Produktbild folgt der Maus (mit Sheen)
     ================================================================= */
  function initTilt(el, opts) {
    if (REDUCED || COARSE || el.dataset.nxTiltBound) return;
    el.dataset.nxTiltBound = '1';
    var max = (opts && opts.max) || 9, scale = (opts && opts.scale) || 1.02;
    var tx = 0, ty = 0, cx = 0, cy = 0, running = false;

    if (opts && opts.sheen !== false) {
      var sh = document.createElement('span');
      sh.className = 'nx-fx-sheen'; sh.setAttribute('aria-hidden', 'true');
      el.appendChild(sh);
    }
    function loop() {
      cx = lerp(cx, tx, .12); cy = lerp(cy, ty, .12);
      el.style.transform = 'perspective(900px) rotateX(' + (-cy * max).toFixed(2) +
        'deg) rotateY(' + (cx * max).toFixed(2) + 'deg) scale(' + (tx || ty ? scale : 1) + ')';
      if (Math.abs(cx - tx) > .001 || Math.abs(cy - ty) > .001) raf(loop); else running = false;
    }
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      tx = (px - .5) * 2; ty = (py - .5) * 2;
      el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      el.classList.add('is-tilting');
      if (!running) { running = true; raf(loop); }
    });
    el.addEventListener('pointerleave', function () {
      tx = 0; ty = 0; el.classList.remove('is-tilting');
      if (!running) { running = true; raf(loop); }
    });
  }

  /* =================================================================
     3) MAGNETISCHE BUTTONS
     ================================================================= */
  function initMagnet(el) {
    if (REDUCED || COARSE || el.dataset.nxMagBound) return;
    el.dataset.nxMagBound = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
      var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
      el.style.transform = 'translate(' + (dx * 5).toFixed(1) + 'px,' + (dy * 4).toFixed(1) + 'px)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  /* =================================================================
     4) COUNT-UP für Zahlen
     ================================================================= */
  function initCount(el) {
    if (el.dataset.nxCountBound) return; el.dataset.nxCountBound = '1';
    var raw = (el.textContent || '').trim();
    var m = raw.match(/([\d.,]+)/); if (!m) return;
    var target = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
    if (!isFinite(target)) return;
    var dec = (m[1].split(',')[1] || '').length;
    var pre = raw.slice(0, m.index), post = raw.slice(m.index + m[1].length);
    new IntersectionObserver(function (es, o) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; o.disconnect();
        if (REDUCED) return;
        var t0 = performance.now(), dur = 1300;
        (function step(t) {
          var p = clamp((t - t0) / dur, 0, 1);
          var e2 = 1 - Math.pow(1 - p, 3);
          var v = (target * e2).toFixed(dec).replace('.', ',');
          el.textContent = pre + (dec ? v : Number(v.replace(',', '.')).toLocaleString('de-DE')) + post;
          if (p < 1) raf(step);
        })(t0);
      });
    }, { threshold: .4 }).observe(el);
  }

  /* =================================================================
     5) SCROLL-PARALLAX + Fortschrittsbalken (ein gemeinsamer Handler)
     ================================================================= */
  var paraEls = [], progress = null, ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    raf(function () {
      var vh = innerHeight;
      for (var i = 0; i < paraEls.length; i++) {
        var el = paraEls[i], r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) continue;
        var mid = r.top + r.height / 2, off = (mid - vh / 2) / vh;
        var amt = parseFloat(el.dataset.nxParallax) || 18;
        el.style.transform = 'translate3d(0,' + (-off * amt).toFixed(1) + 'px,0)';
      }
      if (progress) {
        var d = document.documentElement;
        var p = d.scrollTop / Math.max(1, d.scrollHeight - d.clientHeight);
        progress.style.width = (p * 100).toFixed(2) + '%';
      }
      ticking = false;
    });
  }

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  /* =================================================================
     BOOT — Effekte an bekannte Strukturen hängen
     ================================================================= */

  /* Bilder, die nicht laden, sauber entfernen statt leere Kästen zu zeigen */
  function nxHideBroken(root){
    (root||document).querySelectorAll('img').forEach(function(im){
      var kill=function(){ im.style.display='none'; var w=im.closest('[class*="__tile"],[class*="__media"]'); if(w&&!w.querySelector('img:not([style*="none"]),video')) w.style.display='none'; };
      if(im.complete){ if(im.naturalWidth===0) kill(); }
      else im.addEventListener('error', kill, {once:true});
    });
  }

  function boot(root) {
    root = root || document;

    // Hero
    var hero = $('.nx-hero', root);
    if (hero) {
      initParticles(hero);
      var media = $('.nx-hero__media', hero);
      if (media) {
        media.setAttribute('data-nx-tilt', '');
        media.classList.add('nx-fx-halo', 'nx-fx-ring');
        var im = $('img', media); if (im) im.classList.add('nx-fx-float');
        initTilt(media, { max: 8, scale: 1.015 });
      }
    }

    // Spotlight-Bild: Parallax + leichter Tilt
    $$('.nx-spotlight .nx-card--dark, [class*="spotlight"] .nx-card--dark', root).forEach(function (el) {
      el.setAttribute('data-nx-parallax', '22');
      el.classList.add('nx-fx-halo');
      initTilt(el, { max: 6, scale: 1.01 });
      if (paraEls.indexOf(el) < 0) paraEls.push(el);
    });

    // Produkt-/Bundle-/Addon-Karten: dezenter 3D-Tilt
    $$('.nx-card, [class*="__card"]', root).forEach(function (el) {
      if (el.closest('.nx-hero')) return;
      if (el.dataset.nxCard3d) return;
      el.setAttribute('data-nx-card3d', '');
      initTilt(el, { max: 4, scale: 1.012, sheen: false });
    });

    // Primär-Buttons magnetisch
    $$('.nx-btn--blue', root).forEach(function (el) {
      el.setAttribute('data-nx-magnet', ''); initMagnet(el);
    });

    // Zahlen animieren (Social-Band / Stats)
    $$('[data-nx-count]', root).forEach(initCount);

    // Gestaffelte Reveals innerhalb einer Gruppe
    $$('.nx-head + *, [class*="__grid"], [class*="__row"]', root).forEach(function (grp) {
      var kids = $$('.nx-rv', grp);
      kids.forEach(function (k, i) { if (!k.style.getPropertyValue('--nx-d')) k.style.setProperty('--nx-d', (i * 70) + 'ms'); });
    });

    nxHideBroken(root);
    onScroll();
  }

  function ready() {
    if (!REDUCED) {
      progress = document.createElement('div');
      progress.className = 'nx-fx-progress';
      progress.setAttribute('aria-hidden', 'true');
      document.body.appendChild(progress);
    }
    boot();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', debounce(onScroll, 150));
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
